export default __webpack_public_path__ + "6ef675b00f49d50f530fe628000e18ba.png";